import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { ContractStatusDto, NeedStatus, ProjectStatus, PublicEventStatusDto } from "../../autogen/bff-api";
import { needStatusLabel } from "../needs/useNeedStatusLabel";
import { contractStatusLabel } from "../contracts/ContractStatusTag";
import { projectStatusLabel } from "../projects/useProjectStatuses";
import { publicStatusLabel } from "../sourcing-events/EventStatusTag";
import { useProcurementTerms } from "../terminology/useProcurementTerms";
import type { StatusLabel } from "./listResults";

export const useListStatusLabel = (): StatusLabel => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  return useCallback(
    (toolName: string, status: string) => {
      switch (toolName) {
        case "listBuyerEvents":
          return publicStatusLabel(status as PublicEventStatusDto, t, terms.publishedStatus);
        case "listContractReports":
          return contractStatusLabel(status as ContractStatusDto, t) ?? status;
        case "getProjects":
          return projectStatusLabel(status as ProjectStatus, t) ?? status;
        case "listNeeds":
          return needStatusLabel(status as NeedStatus, t) ?? status;
        default:
          return status;
      }
    },
    [t, terms.publishedStatus],
  );
};
